import i18next from 'i18next';

i18next.init({
    fallbackLng: 'en',
    resources: {
        'ru': {
            common:  require('../locales/ru/common.json'),
            aboutus:  require('../locales/ru/aboutus.json'),
            content:  require('../locales/ru/content.json'),
            branding:  require('../locales/ru/branding.json'),
            colors:  require('../locales/ru/colors.json'),
            logo:  require('../locales/ru/logo.json'),
            typography:  require('../locales/ru/typography.json'),
        },
        en: {
            common:  require('../locales/en/common.json'),
            aboutus:  require('../locales/en/aboutus.json'),
            content:  require('../locales/en/content.json'),
            branding:  require('../locales/en/branding.json'),
            colors:  require('../locales/en/colors.json'),
            logo:  require('../locales/en/logo.json'),
            typography:  require('../locales/en/typography.json'),
        }
    },
    ns: ['common'],
    defaultNS: 'common',
    returnObjects: true,
    debug: process.env.NODE_ENV === 'development',
    // interpolation: {
    //     escapeValue: false, // not needed for react!!
    // },
    nsSeparator: ">",
    react: {
        useSuspense: true,
    }
});

i18next.languages = ['ru', 'en'];

export default i18next;